import { format as dateFnsFormat } from 'date-fns';
import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { initReactI18next } from 'react-i18next';
import { VERSION } from './setting.json';

i18next
  .use(Backend)
  .use(intervalPlural)
  .use(initReactI18next)
  .init({
    ns: ['public'],
    defaultNS: 'public',
    fallbackNS: 'public',
    lng: 'en-gb',
    fallbackLng: 'en-gb',
    lowerCaseLng: true,
    load: 'currentOnly',
    keySeparator: false,
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/translations/{{lng}}/{{ns}}.{{lng}}.json`,
      queryStringParams: { v: VERSION },
    },
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default',
    },
    interpolation: {
      format: (value, format) => {
        if (value instanceof Date) return dateFnsFormat(value, format);
        return value;
      },
      escapeValue: false,
    },
  });

export default i18next;
